import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading placeholder for the product reviews tab.
 * Mirrors the real layout (summary row + a few review cards) so the
 * content does not jump when data arrives.
 */
export const ReviewsSkeleton: React.FC = () => {
  return (
    <div className="py-4 space-y-6" aria-hidden="true">
      {/* Summary row */}
      <div className="flex items-center gap-3">
        <Skeleton variant="muted" className="h-7 w-10" />
        <Skeleton variant="muted" className="h-4 w-28" />
      </div>

      {/* Review cards */}
      <div className="space-y-1">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="border-b last:border-b-0 border-stroke-light py-4 space-y-2"
          >
            <div className="flex items-center justify-between gap-2">
              <Skeleton variant="muted" className="h-4 w-24" />
              <Skeleton variant="muted" className="h-3 w-20" />
            </div>
            <Skeleton variant="muted" className="h-3 w-3/4" />
            <Skeleton variant="muted" className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    </div>
  );
};
